import { defineComponent, h } from 'vue';
import utils from '../../../Shared/utils.jsx';
import BaseComponent from './BaseComponentMixin.jsx';

export default defineComponent({
    mixins: [BaseComponent],
    data: function () {
        return {
        }
    },
    props: {
        type: null,
        schemakey: null,
    },
    render() {
        let name;
        if (!this.name)
            name = this.type || 'Unnamed';
        else if (typeof this.name === 'string')
            name = this.name + ':' + this.type || 'Unnamed';
        else
            name = this.type || this.schemakey || '';

        return (
            <div
                class={{ 'designer-container': true, selected: this.selected$ }}
                style={{ backgroundColor: "#a0ffa0", ...utils.getSize(this.controlData ? this.controlData.SizeOptions : null, this.parentType, this.$parent) }}
                onClick={(e) => this.handleClick(e)}>
                <div class={{ "designer-container-hovering": true, 'designer-container-selected': this.selected$ }}></div>
                {name}<br />
            </div>
        );
    }
});

/*
Vue.component('default-unknown-dsgn', {
    mixins: [defaultMixin]
});

Vue.component('interval-dsgn', {
    mixins: [defaultMixin]
});

Vue.component('broadcast-listener-dsgn', {
    mixins: [defaultMixin]
});

Vue.component('css-style-dsgn', {
    mixins: [defaultMixin]
});

Vue.component('infinite-grid-dsgn', {
    mixins: [defaultMixin]
});

Vue.component('slim-grid-dsgn', {
    mixins: [defaultMixin]
});

Vue.component('date-range-picker-dsgn', {
    mixins: [defaultMixin]
});

Vue.component('dropdown-multi-select-dsgn', {
    mixins: [defaultMixin]
});

Vue.component('basic-input-dsgn', {
    mixins: [defaultMixin]
});

Vue.component('html-component-dsgn', {
    mixins: [defaultMixin]
});

Vue.component('basic-file-upload-dsgn', {
    mixins: [defaultMixin]
});

Vue.component('popup-menu-button-dsgn', {
    mixins: [defaultMixin]
});

Vue.component('rt-event-handler-dsgn', {
    mixins: [defaultMixin]
});

Vue.component('flow-chart-dsgn', {
    mixins: [defaultMixin]
});

Vue.component('soft-phone-dsgn', {
    mixins: [defaultMixin]
});

Vue.component('dash-dsgn', {
    mixins: [defaultMixin]
});

Vue.component('cc-timeline-dsgn', {
    mixins: [defaultMixin]
});

Vue.component('infinite-conversation-view-dsgn', {
    mixins: [defaultMixin]
});

Vue.component('rooster-editor-dsgn', {
    mixins: [defaultMixin]
});

Vue.component('google-button-dsgn', {
    mixins: [defaultMixin]
});

Vue.component('apple-button-dsgn', {
    mixins: [defaultMixin]
});

Vue.component('acd-direct-button-dsgn', {
    mixins: [defaultMixin]
});

Vue.component('server-event-listener-dsgn', {
    mixins: [defaultMixin]
});

Vue.component('saml-button-dsgn', {
    mixins: [defaultMixin]
});

Vue.component('text-editor-dsgn', {
    mixins: [defaultMixin]
});

Vue.component('circle-chart-dsgn', {
    mixins: [defaultMixin]
});

Vue.component('bar-chart-dsgn', {
    mixins: [defaultMixin]
});

//Vue.component('real-time-grid-dsgn', {
//    mixins: [defaultMixin]
//});

Vue.component('realtime-widget-listener-dsgn', {
    mixins: [defaultMixin]
});

Vue.component('advanced-history-dsgn', {
    mixins: [defaultMixin]
});

Vue.component('advanced-reports-dsgn', {
    mixins: [defaultMixin]
});
*/